import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
} from "@angular/core";

import { NotificationListConfig, User } from "../../../../models";

@Component({
  selector: "notification-alerts-modal",
  templateUrl: "./notification-alerts-modal.component.html",
  styleUrls: [
    "./notification-alerts-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationAlertsModal implements OnInit {
  // list component inputs
  @Input() limit: number;
  @Input() config: NotificationListConfig;
  @Input() currentUser: User;
  @Output() confirmAlert = new EventEmitter<any>();

  // modal inputs
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public alertUser(event) {
    this.confirmAlert.emit(event);
  }

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
